import React, { useState } from 'react';
import SearchInput from '@tcs/client-portal-common/components/molecules/Search';
import { Typography, palette } from '@forgeglobal/design-framework';
import useSearch from '@tcs/client-portal-common/hooks/useSearch';
import { SearchInputType } from '@tcs/client-portal-common/components/molecules/Search/types';
import { useStyles } from './style';

interface SearchPageProps {
  savedItemsKey: string;
  type: SearchInputType;
}

const Search = ({ savedItemsKey, type }: SearchPageProps) => {
  const classes = useStyles();

  const [searchedValue, setSearchedValue] = useState('');
  const { data, loading } = useSearch(
    searchedValue,
    undefined,
    undefined,
    undefined,
    false,
    true
  );
  return (
    <div className={classes.wrapper}>
      <Typography variant="h5" className={classes.title}>
        Search for an account to view:
      </Typography>
      <div className={classes.input}>
        <SearchInput
          onSearch={(val) => {
            setSearchedValue(val);
          }}
          items={data}
          savedKey={savedItemsKey}
          loading={loading}
          type={type}
        />
      </div>
    </div>
  );
};

export default Search;
